import { TpvDispersion } from '@app/domain/models/tpv/dispersion.model';
import { DispersionDto } from '@app/data/dtos/tpv/dispersion.dto';

/** DTO de dispersión -> entidad de dominio (id_merchant = UUID). */
export function mapDispersion(dto: DispersionDto): TpvDispersion {
  return {
    idDispersion: Number(dto.id_dispersion ?? 0),
    externalIdMerchant: dto.id_merchant ?? '',
    companyName: dto.company_name ?? '',
    unitName: dto.unit_name ?? '',
    merchantName: dto.merchant_name ?? '',
    processor: dto.processor ?? '',
    date: dto.date ?? '',
    receivedMerchantAmount: Number(dto.received_merchant_amount ?? 0),
    status: dto.status ?? '',
  };
}
